import { AuthUser } from 'src/modules/common/types/AuthUser';
import { createTrigger } from 'src/utils/createTrigger';

export const WHOAMI_ACTION = createTrigger<AuthUser | null>('WHOAMI');
